const translations = {
  title: 'Rutinas',
  title_routines: 'Rutinas',
  new_routines: 'Nueva Rutina',
  new: 'Nueva Rutina',
  modalTitle: 'Nueva rutina',
  modalTitle_edit: 'Editando rutina',
  name: 'Nombre',
  nameRequired: 'Nombre*',
  folder: 'Carpeta',
  quantity: 'Cantidad',
  activitiesRequired: 'Actividades*',
  configureActivities: '+ Configurar Actividades',
  customizeRecurrence: 'Personalizar Recurrencia*',
  repeatEvery: 'Repetir cada',
  repeat: 'Repetir',
  startsAt: 'Comienza en',
  endsAt: 'Termina',
  never: 'Nunca',
  on: 'En',
  'frequencyOptions.day': 'Día',
  'frequencyOptions.week': 'Semana',
  'frequencyOptions.year': 'Año',
  mustHaveAtLeastOneActivity: 'Debe tener al menos 1 actividad',
  checkActivities: 'Verifique las actividades',
  cannotBeLessOrEqualToZero: 'No puede ser menor o igual a cero',
  startDateMustBeGreaterThanCurrent: 'La fecha de inicio debe ser mayor que la fecha actual.',
  endDateMustBeGreaterThanStart: 'La fecha de término debe ser mayor que la fecha de inicio.'
}

export default translations
